import { render, staticRenderFns } from "./addSetMenu.vue?vue&type=template&id=188e1779&scoped=true"
import script from "./addSetMenu.vue?vue&type=script&lang=js"
export * from "./addSetMenu.vue?vue&type=script&lang=js"
import style0 from "./addSetMenu.vue?vue&type=style&index=0&id=188e1779&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e1779",
  null
  
)

export default component.exports